import React, { useState } from 'react';
import { LFC } from '../../../Legacy';
import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { useSubmitter } from '../../../platform/Hook';
import { Button, Colors, Input, Prompt } from '../../../ui';
import { StarRating } from '../../../ui/StarRating';
import { useResolve } from '../../Container';
import { Copy, Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';
import { PopupManager } from '../../popups/PopupManager';
import { meetingFeedbackThanksPopup } from './MeetingFeedbackThanksPopup';

export const meetingFeedbackPopup = (rating: number) => ({ ui: MeetingFeedbackPopup, fade: false, args: { rating } });

export const MeetingFeedbackPopup: LFC<PopupProps> = ({ dismiss, args }) => {

    const api = useResolve(ApiClient);
    const popups = useResolve(PopupManager);

    const [rating, setRating] = useState(args.rating ?? 0);
    const [message, setMessage] = useState('');

    const [onSubmit] = useSubmitter(async () => {
        await api.exec(v2.me.feedback({
            type: { key: 'rating', label: `Rating of ${rating} / 5` },
            message: message.trim() || 'No message provided.',
        }));
        popups.invoke(meetingFeedbackThanksPopup());
    }, [rating, message]);

    return <Prompt ignoreEnter onAction={dismiss}>
        <Popup w="34" p="0" shadow="lg" style={{ overflow: 'hidden' }}>
            <Flexer flex="column" center gap="1" padding="2" background={Colors.positive}>
                <Flexer flex="column" gap=".5" style={{ textAlign: 'center' }}>
                    <Title flush size="xl" color="white">Anything else to add?</Title>
                    <Copy color="rgba(255,255,255,0.8)">(It's cool if not, just hit submit!)</Copy>
                </Flexer>
                <Flexer>
                    <StarRating size={5} initialValue={rating} onSelect={setRating} />
                </Flexer>
                <Flexer width={28}>
                    <Input multiline={{ rows: 5, resize: 'none' }} value={message} onChange={setMessage} />
                </Flexer>
                <Popup.Actions style={{ color: 'white' }}>
                    <Button onAction={onSubmit}>Submit</Button>
                    <Button onAction={dismiss}>Cancel</Button>
                </Popup.Actions>
            </Flexer>
        </Popup>
    </Prompt>;
};
